module.exports = __webpack_public_path__ + "img/noshow.1d190029.svg";